import { useState } from 'react';

import type { DiscountType } from '../api/discount/discount.types';
import { downloadDiscountExcel } from '../api/discount/discountCalls';

export function DiscountDownload(props: { discountType: DiscountType }) {
    const [isDownloading, setIsDownloading] = useState(false);

    return (
        <button
            type={'button'}
            key={isDownloading ? 'down' : 'ready'}
            className={`btn btn-default ${isDownloading ? 'btn-loading' : ''}`}
            disabled={isDownloading}
            onClick={() => downloadDiscountExcel(setIsDownloading, props.discountType)}
        >
            {!isDownloading && <span className='uikit-icon icon-cloud-download' aria-hidden='true' />}
            Export all discounts
        </button>
    );
}
